import { css } from '@linaria/core';
export const container = "omponents__CollapsibleSection__styles_ts-container-c3xw760";
export const headerContainer = "omponents__CollapsibleSection__styles_ts-headerContainer-hv12lni";
export const contentContainer = "omponents__CollapsibleSection__styles_ts-contentContainer-c9up3th";
export const caretIcon = "omponents__CollapsibleSection__styles_ts-caretIcon-c1kzudqv";

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");